import React, {useMemo} from 'react';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

type Props = {
    actionTypeCode: string,
    actionTypeDictionary: DictionaryItem[],
};

export const ActionTypeCell = ({actionTypeCode, actionTypeDictionary}: Props) => {
    const actionTypeDescription = useMemo(() => {
        const actionType = actionTypeDictionary.find(item => item.code === actionTypeCode);
        return actionType?.description || actionTypeCode;
    }, [actionTypeCode, actionTypeDictionary]);

    return (
        <EllipsisTextHint title={actionTypeDescription}>
            <strong>{actionTypeDescription}</strong>
        </EllipsisTextHint>
    );
};
